import { useCallback, useContext, useMemo } from 'react';
import FeaturesContext, { Features, FeaturesContextType } from 'context/FeaturesContext';
import { CheckFeatureFunction } from './types';

const useCheckFeatures = (): [Features, (enabler: string) => boolean] => {
  const { features } = useContext<FeaturesContextType>(FeaturesContext);

  const enabledFeatures = useMemo(
    () =>
      new Set(
        Object.entries(features)
          .filter(([, isEnabled]) => isEnabled)
          .map(([feature]) => feature)
      ),
    [features]
  );

  const checkFeature: CheckFeatureFunction = useCallback(enabler => enabledFeatures.has(enabler), [enabledFeatures]);

  return [features, checkFeature] as const;
};

export default useCheckFeatures;
